<template>
  <div class="app">
    <Loading :value="loading"></Loading>
    <!-- MODAL DETAILS DE COMMANDE -->
    <v-dialog
      v-model="dialogDetailCommande"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>
              {{
                hiddenButton
                  ? "Détails du bon de commande interne"
                  : "Détails de la commande Interne"
              }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip text-color="white" label color="primary" style="width:100%">
              {{
                hiddenButton
                  ? "DETAILS DU BON DE COMMANDE INTERNE"
                  : " DETAILS DE LA COMMANDE INTERNE"
              }}

             
              <v-icon right>shopping_cart</v-icon>
            </v-chip>
          </p>

          <v-form lazy-validation id="formComm">
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex v-if="!hiddenButton">
                  <span class="demonstration">Fournisseur </span>
                  <el-input
                    v-model="fournisseurCommande"
                    placeholder="Fournisseur"
                    style="width:100%"
                    :readonly="true"
                  ></el-input>
                </v-flex>
                <v-flex :md4="!hiddenButton" :md7="hiddenButton">
                  <div class="block">
                    <span class="demonstration">Intitulé de la commande</span>
                    <el-input
                      name="libelle"
                      placeholder="Intitulé de la commande"
                      v-model="libelleCommande"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex v-if="!hiddenButton">
                  <div class="block">
                    <span class="demonstration">Mode</span>
                    <el-input
                      name="mode"
                      placeholder="Intitulé de la commande"
                      v-model="modeCommande"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex v-if="!hiddenButton">
                  <div class="block">
                    <span class="demonstration">Numéro devis / proforma</span>
                    <el-input
                      name="mode"
                      placeholder="Numero devis / proforma"
                      v-model="numeroDevis"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de livraison</span>
                    <el-input
                      v-model="dateLivraison"
                      id="dateLivraison"
                      placeholder="Date de livraison"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Priorité</span>
                    <el-input
                      v-if="prioriteCommande == 1"
                      value="Faible"
                      :trigger-on-focus="true"
                      :readonly="true"
                    ></el-input>
                    <el-input
                      v-else-if="prioriteCommande == 2"
                      value="Normal"
                      :trigger-on-focus="true"
                      :readonly="true"
                    ></el-input>
                    <el-input
                      v-else-if="prioriteCommande == 3"
                      value="Urgent"
                      :trigger-on-focus="true"
                      :readonly="true"
                    ></el-input>
                    <el-input
                      v-else
                      value="Aucune"
                      :trigger-on-focus="true"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <!-- MAINTENANCE -->
              <v-layout v-if="detailCommande && detailCommande.entrepotId" row>
                <v-flex md4>
                  <div class="block">
                    <el-input
                      v-model="detailCommande.libEntrepot"
                      placeholder="Magasin chantier"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row v-if="detailCommande && detailCommande.projetId">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Projet concerné </span>
                    <el-input
                      v-model="projetS"
                      id="projetS"
                      placeholder="Type de projet"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Chantier concerné </span>
                    <el-input
                      v-model="chantierS"
                      id="chantierS"
                      placeholder="Chantier concerné"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Travaux </span>
                    <el-input
                      v-model="travauxS"
                      id="travauxS"
                      placeholder="Travaux"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>               
              </v-layout>
              <v-layout row v-if="detailCommande && detailCommande.projetId">              
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Tâche</span>
                    <el-input
                      v-model="tacheS"
                      id="tacheS"
                      placeholder="Tache"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">PK début</span>
                    <el-input
                      name="tranconA"
                      placeholder="Du PK"
                      v-model="tranconA"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">PK fin</span>
                    <el-input
                      name="tranconB"
                      placeholder="PK FIN"
                      v-model="tranconB"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <v-avatar
                      slot="activator"
                      v-if="urlImage"
                      @click="showDiapo([urlImage], 0, urlImage)"
                      :style="{
                          backgroundImage: 'url(' + urlImage + ')',
                          cursor: 'pointer'
                      }"
                      :tile="true"
                      :size="150"
                      color="grey lighten-4"
                      class="mb-1 mr-1 elevation-3"
                  >
                  <img v-if="imagePdf" :src="logoPdf" alt="avatar">
                  <img v-if="!imagePdf" :src="logoDefaut" alt="avatar">
<!-- 
                      <img :src="urlImage" alt="avatar" /> -->
                  </v-avatar>
                </v-flex>              
              </v-layout>

             

              <p align="center">
                <v-chip
                  outline
                  text-color="primary"
                  label
                  color="primary"
                  style="width:100%"
                >
                  PRODUIT(S) LIE(S) A LA COMMANDE
                  <v-icon right>shopping_cart</v-icon>
                </v-chip>
              </p>

              <v-layout row v-for="besoin in optionBesoin" :key="besoin.key">
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Code analytique</span>
                    <el-input
                      v-model="besoin.codeAnalytique"
                      name="produit"
                      placeholder="Code analytique"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Code gestion</span>
                    <el-input
                      v-model="besoin.codeGestion"
                      name="gestion"
                      placeholder="Code gestion"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex :md4="!hiddenButton" :md7="hiddenButton">
                  <div class="block">
                    <span class="demonstration">Ressource</span>
                    <el-input
                      v-model="besoin.produit"
                      name="produit"
                      placeholder="Ressource"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Quantité</span>
                    <el-input
                      type="number"
                      value="qte"
                      placeholder="Quantité"
                      v-model="besoin.qte"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2 v-if="!hiddenButton">
                  <div class="block">
                    <span class="demonstration">Prix unitaire *</span>
                    <el-input
                      type="number"
                      value="prix"
                      placeholder="Prix"
                      v-model="besoin.prix"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Unité</span>
                    <el-input
                      class="inline-input"
                      v-model="besoin.unite"
                      :trigger-on-focus="true"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <br />
            </v-container>

            <v-btn @click="closeDialog()" color="blue" dark
              >Fermer<v-icon right>close</v-icon></v-btn
            >
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <CoolLightBox :items="items" :index="index" @close="index = null">
        </CoolLightBox>

  </div>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  name: "ModalCommandeDetails",
  props: ["show", "detailCommande", "hiddenButton"],

  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,

      fournisseur: null,
      priorite: 1,
      dateLivraison: null,
      libelleCommande: "",
      prioriteCommande: 1,
      idCommande: 0,
      modeCommande: null,
      numeroDevis: null,
      imagePdf: false,
      fournisseurCommande: null,

      dialogDetailCommande: false,
      optionBesoin: [
        {
          key: 1,
          produit: "",
          qte: 1,
          unite: "",
          id: 0,
          priorite: 1
        }
      ],

      items: [],
      index: null,
      //Projet
      listeProjet: [],
      listeChantier: [],
      listeTravaux: [],
      listeTacheTrx: [],
      projetS: "",
      chantierS: "",
      travauxS: "",
      tacheS:'',
      tranconA: '',
      urlImage: '',
      logoDefaut: '/static/img-doc.png',
      logoPdf: '/static/pdf.png',
      tranconB: '',

      priorites: [
        {
          value: 1,
          label: "Faible"
        },
        {
          value: 2,
          label: "Normal"
        },
        {
          value: 3,
          label: "Urgent"
        }
      ]
    };
  },

  computed: {},

  methods: {
    loadProjet() {
      let url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProjet = response.body.projet;
          this.projetS = this.detailCommande.projet;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },
    showDiapo(images, ind, image) {
        this.items = images;
        this.index = ind;
      },
    loadChantier() {
      this.loading = true;
      let url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeChantier = response.body.chantier;
          this.chantierS = this.detailCommande.chantier;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },

    loadTravaux() {
      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
    if (this.chantierS !== "") {
        let url =
          this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeTravaux = response.body.travaux;
            this.travauxS = this.detailCommande.travaux;
             console.log('this.travauxS',this.travauxS)
            this.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },    
    loadTacheTrx() {
      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      console.log("this.travauxS",this.travauxS)
      if (this.travauxS !== "" || this.travauxS !== undefined) {
        let url = this.domaine + "tache/travaux/" + this.travauxS;
        this.$http.get(url).then(response => {
          this.listeTacheTrx = response.body.taches;
          this.tacheS = this.detailCommande.tache;
          this.loading = false;
          console.log('jaffiche', this.tache)
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },
    loadDetailsCommande() {
      this.optionBesoin = this.detailCommande.option;
      this.idCommande = this.detailCommande.id;
      this.libelleCommande = this.detailCommande.libelle;
      this.prioriteCommande = this.detailCommande.priorite;
      this.dateLivraison = this.detailCommande.dateLivr;
      this.fournisseurCommande = this.detailCommande.fournisseurNom;
      this.modeCommande = this.detailCommande.mode;
      this.numeroDevis = this.detailCommande.numeroDevis
      //projet
      console.log('this.detailCommande',this.detailCommande)
      this.projetS = this.detailCommande.projetId;
      this.chantierS = this.detailCommande.chantierId;
      this.travauxS = this.detailCommande.travauxId;
      this.tacheS = this.detailCommande.tache;
      this.tranconA=  this.detailCommande.tranconA;
      this.tranconB=  this.detailCommande.tranconB;
      this.urlImage=  this.detailCommande.urlImage;
      let valeur =  this.urlImage.substring(this.urlImage.lastIndexOf(".") + 1)      
      console.log('valeur',valeur)
      this.imagePdf = false         
      if(valeur == 'pdf') {
          this.imagePdf = true
        }


      console.log('this.tacheS',this.tacheS)
    },
    closeDialog() {
      this.$emit("close");
    }
  },

  watch: {
    show: function(newValue, oldvalue) {
      if (newValue == true) {
        this.loadDetailsCommande();       
        if (this.detailCommande.projetId) {
          this.loadProjet();
          this.loadChantier();
          this.loadTravaux();
          // this.loadTacheTrx();
        }

      }
      this.dialogDetailCommande = newValue;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/besoin/ModalCommandeDetails.vue